/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
(function (global) {
  global.ng ??= {};
  global.ng.common ??= {};
  global.ng.common.locales ??= {};
  const u = undefined;
  function plural(val) {
    const n = val;
    return 5;
  }
  global.ng.common.locales['th'] = ["th", [["a", "p"], ["ก่อนเที่ยง", "หลังเที่ยง"], u], [["ก่อนเที่ยง", "หลังเที่ยง"], u, u], [["อา", "จ", "อ", "พ", "พฤ", "ศ", "ส"], ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."], ["วันอาทิตย์", "วันจันทร์", "วันอังคาร", "วันพุธ", "วันพฤหัสบดี", "วันศุกร์", "วันเสาร์"], ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."]], u, [["ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.", "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."], u, ["มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"]], u, [["ก่อน ค.ศ.", "ค.ศ."], u, ["ปีก่อนคริสตกาล", "คริสต์ศักราช"]], 0, [6, 0], ["d/M/yy", "d MMM y", "d MMMM G y", "EEEEที่ d MMMM G y"], ["HH:mm", "HH:mm:ss", "H นาฬิกา mm นาที ss วินาที z", "H นาฬิกา mm นาที ss วินาที zzzz"], ["{1} {0}", u, u, u], [".", ",", ";", "%", "+", "-", "E", "×", "‰", "∞", "NaN", ":"], ["#,##0.###", "#,##0%", "¤#,##0.00", "#E0"], "THB", "฿", "บาท", {
    "AUD": ["AU$", "$"],
    "BYN": [u, "р."],
    "PHP": [u, "₱"],
    "THB": ["฿"],
    "TWD": ["NT$"],
    "USD": ["US$", "$"],
    "XXX": []
  }, "ltr", plural, [[["เที่ยงคืน", "เที่ยง", "เช้า", "เที่ยง", "บ่าย", "เย็น", "ค่ำ", "กลางคืน"], ["เที่ยงคืน", "เที่ยง", "ในตอนเช้า", "ในตอนบ่าย", "บ่าย", "ในตอนเย็น", "ค่ำ", "กลางคืน"], u], [["เที่ยงคืน", "เที่ยง", "เช้า", "ช่วงเที่ยง", "บ่าย", "เย็น", "ค่ำ", "กลางคืน"], ["เที่ยงคืน", "เที่ยง", "ในตอนเช้า", "ในตอนบ่าย", "บ่าย", "ในตอนเย็น", "ค่ำ", "กลางคืน"], u], ["00:00", "12:00", ["06:00", "12:00"], ["12:00", "13:00"], ["13:00", "16:00"], ["16:00", "18:00"], ["18:00", "21:00"], ["21:00", "06:00"]]]];
})(globalThis);